export default {
  0: (state: any) => ({
    ...state,
  }),
  1: (state: any) => ({
    ...state,
    byCategory: undefined,
  }),
};
